import React from "react";

const Cta = () => {
  return (
    <a
      href="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
      target="_blank"
      rel="noopener noreferrer"
      className="button main-cta boldTitle"
    >
      Book Now!
    </a>
  );
};

export default Cta;
